import { api } from './api';

export const getNotifications = (params?: { cursor?: string; limit?: number }) =>
  api.get('/admin/notifications', { params });
export const sendNotification = (data: { title: string; body: string; targetRole: string }) =>
  api.post('/admin/notifications', data);
